<template>
    <v-container
        class="align-start"
        :fluid="$route.meta.fluid === true || ($route.meta.lgAndDownFluid === true && $vuetify.breakpoint.lgAndDown)"
        :class="[
            $vuetify.breakpoint.smAndDown ? 'pa-0' : '',
            $route.meta.noPadding ? 'pa-0' : '',
            $route.meta.noBottomPadding ? 'pb-0' : 'pb-12'
        ]"
        :style="$vuetify.breakpoint.smAndDown ? 'background-color: white' : ''"
    >
        <router-view />
    </v-container>
</template>

<script>
export default {
    name: "RegularWrapper"
};
</script>
